export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand Column */}
            <div>
              <Link to="/" className="font-heading text-lg font-bold text-foreground-900">
                LitBuy <span className="text-primary-500">Spreadsheet</span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                Your trusted resource for mastering LitBuy Spreadsheet. Comprehensive guides, templates, comparisons, and expert tips to boost your productivity.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/litbuy-spreadsheet" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Ultimate Guide</Link>
                <Link to="/guides/what-is-litbuy-spreadsheet" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">What Is LitBuy?</Link>
                <Link to="/guides/how-to-use-litbuy-spreadsheet" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">How to Use</Link>
                <Link to="/guides/litbuy-beginner-guide" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Beginner Guide</Link>
              </div>
            </div>

            {/* Comparisons */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Comparisons</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/comparisons/litbuy-vs-google-sheets" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">vs Google Sheets</Link>
                <Link to="/comparisons/litbuy-vs-excel" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">vs Excel</Link>
              </div>
            </div>

            {/* Legal & Resources */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  Visit Main Site
                </a>
                <Link to="/safety" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Safety</Link>
                <Link to="/privacy-policy" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Privacy Policy</Link>
                <Link to="/disclaimer" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Disclaimer</Link>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} LitBuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}